<template>
    <v-card
            class="card"
            :class="getClassName"
    >
        <div
                v-if="showHeader"
                class="card__header"
        >
            <div class="card__header-wrap">
                <div
                        class="card__accent card__accent-icon elevation-4"
                        :style="{'background-color': localColor}">
                    <v-icon color="white">{{ icon }}</v-icon>
                </div>
                <div class="card__label" :class="classLabel">
                    <slot name="label">
                        <div class="card__col">
                          <template v-if="!labelRaw">
                            <div class="card__label-top-left">{{ labelTopLeft }}</div>
                            <div class="card__label-bottom-left">{{ labelBottomLeft }}</div>
                          </template>
                          <template v-else>
                            <div class="card__label-top-left" v-html="labelTopLeft"></div>
                            <div class="card__label-bottom-left" v-html="labelBottomLeft"></div>
                          </template>
                        </div>
                        <div class="card__actions">
                            <slot name="header"></slot>
                        </div>
                    </slot>
                </div>
            </div>
            <div
                    :class="{
                        'mb-4': !!$slots.bottom
                    }"
            >
                <slot name="bottom"></slot>
            </div>
        </div>
        <v-card-text
                v-if="!hideContent"
                class="card__content"
                :class="classContent"
        >
            <div v-if="title" class="card__title">{{ title }}</div>
            <slot></slot>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            color: {default: null, type: String},
            labelTopLeft: String,
            labelBottomLeft: String,
            labelRaw: {type: Boolean, default: false},
            icon: {type: String, default: 'mdi-target'},
            hideContent: false,
            className: {type: String, default: null},
            classContent: {type: String, default: null},
            classLabel: {type: String, default: null},
            small: {type: Boolean, default: false},
            showHeader: {type: Boolean, default: true},
            title: {type: String, default: null},
        },
        data() {
            return {
                localColor: null
            }
        },
        computed: {
            getClassName() {
                let className = this.className;
                if (this.small) className += ' card_small';
                if (this.$vuetify.breakpoint.xsOnly) className += ' card_mobile';
                return className;
            }
        },
        created() {
            if (this.color === null) {
                this.localColor = this.$vuetify.theme.themes.light.primary;
            }
        }
    }
</script>

<style lang="scss">
    .card {
        $accentIconWidth: 80px;
        $labelWidth: calc(100% - 80px);

        $accentIconWidthSmall: 50px;
        $labelWidthSmall: calc(100% - 50px);

        &.card_max-extra-xs {
          max-width: 400px;
        }
        &.card_max-xs {
            max-width: 600px;
        }
        &.card_max-sm {
            max-width: 960px;
        }
        &.card_max-md {
            max-width: 1264px;
        }
        &.card_max-lg {
            max-width: 1904px;
        }
        &.card_small {
            .card__header {
                min-height: $accentIconWidthSmall;
            }
            .card__accent {
                width: $accentIconWidthSmall;
                height: $accentIconWidthSmall;

                .v-icon {
                    font-size: 30px;
                }
            }
            .card__label {
                width: $labelWidthSmall;
            }
        }
        &.card_mobile {
            //margin-top: 0 !important;

            .card__accent {
                display: none !important;
            }
            .card__actions {
                .v-btn {
                    height: 40px;
                }
                .v-btn--fab {
                    width: 40px;
                }
            }
            .card__label {
                width: 100%;
                padding: 0;
            }
            .card__header-wrap {
                /*justify-content: space-between;*/
                padding: 10px 0;
            }
            .card__header {
                min-height: inherit;
                margin: 0 10px 0 10px;
            }
            .card__content {
                padding: 10px;
            }
        }
        .card__header {
            min-height: $accentIconWidth;
            margin: 15px 15px 0 15px;
            border-bottom: 1px solid #eee;
            /*position: relative;*/

            /*&.card__header_mobile {*/
            /*    .card__label {*/
            /*        padding-top: 8px;*/
            /*        padding-bottom: 0;*/
            /*        justify-content: flex-end;*/
            /*    }*/
            /*}*/
        }
        .card__header-wrap {
            display: flex;
        }
        .card__accent {
            width: $accentIconWidth;
            height: $accentIconWidth;
            position: relative;
            top: -15px;
            border-radius: 4px;

            &.card__accent-icon {
                display: flex;
                justify-content: center;
            }
            .v-icon {
                font-size: 40px;
            }
        }
        .card__col {
            padding-right: 15px;
        }
        .card__label {
            width: $labelWidth;
            height: 100%;
            right: 0;
            padding: 15px 0 15px 15px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            /*margin-left: $accentIconWidth;*/
        }
        .card__label-top-left {
            font-size: 15px;
            font-weight: 300;
            color: rgba(0, 0, 0, 0.87);

            b {
                font-weight: 400;
            }
        }
        .card__label-bottom-left {
            font-size: 13px;
            color: rgba(0, 0, 0, 0.54);
            font-weight: 300;

            b {
                font-weight: 400;
            }
        }
        .card__actions {
            min-height: 30px;
            display: flex;
            align-items: center;
        }
        .card__action {
            max-width: 300px;
            margin-right: 15px;

            &:last-child {
                margin-right: 0;
            }
        }
        .card__multi {
            display: flex;

            &.card__multi_mobile {
                .card__list {
                    width: 100%;
                    max-width: inherit;
                    padding-right: 0;
                }
                .card__detail {
                    width: 100%;
                    padding-left: 0;
                    border-left: none;
                }
            }
        }
        .card__list {
            max-width: 50%;
            flex: 1;
            padding-right: 16px;
        }
        .card__detail {
            width: 50%;
            border-left: 1px solid #eee;
            padding-left: 16px;
        }
        .card__label-mobile {
            padding: 3px 0 6px 0;
            margin-top: -5px;
        }
      .card__title {
        font-size: 15px;
        font-weight: 300;
        color: rgba(0, 0, 0, 0.87);
      }
    }

    @media all and (max-width: 550px) {
        .card {
            .card__col {
                /*display: none;*/
            }
        }
    }
</style>